import React, { useState } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AchCheckImg } from './components/AchCheckImg/AchCheckImg';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../CommonComponents/OPL/Grid/Column';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { Grid } from '../../../../../CommonComponents/OPL/Grid/Grid';
import { AccountType } from './Ach.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Radio } from '../../../../../CommonComponents/OPL/Radio/Radio';
import { Wrapper, WrapperProps } from '../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Label } from '../../../../../CommonComponents/OPL/Label/Label';

export interface AchFields {
  routingNumber: string;
  accountNumber: string;
  accountType: AccountType;
}

interface AchProps extends WrapperProps {
  formBag: UseFormReturn<AchFields>;
}

export const Ach: React.FC<AchProps> = ({
  formBag: {
    register,
    formState: { errors },
    control,
    setValue,
  },
  ...rest
}) => {
  const [focusedNumber, setFocusedNumber] = useState<'routing' | 'account'>();

  return (
    <Wrapper {...rest}>
      <Text fontWeight={600} mt="16" mb="8">
        ACH Info
      </Text>

      <AchCheckImg focusedNumber={focusedNumber} mb="16" />

      <Grid>
        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('routingNumber')}
              label="Routing Number"
              type="text"
              placeholder="Routing Number"
              formVariant={errors.routingNumber ? 'error' : undefined}
              helperText={errors.routingNumber?.message}
              maxLength={9}
              onBlur={() => {
                setFocusedNumber(undefined);
              }}
              onFocus={() => setFocusedNumber('routing')}
              autoComplete="off"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('accountNumber')}
              label="Account Number"
              type="text"
              placeholder="Account Number"
              formVariant={errors.accountNumber ? 'error' : undefined}
              helperText={errors.accountNumber?.message}
              onBlur={() => {
                setFocusedNumber(undefined);
              }}
              onFocus={() => setFocusedNumber('account')}
              autoComplete="off"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Label mb="4">Account Type</Label>

            <Box display="flex">
              <Controller
                control={control}
                name="accountType"
                render={({ field: { value } }) => {
                  return (
                    <>
                      <Radio
                        checked={value === AccountType.Checking}
                        onChange={() => {
                          setValue('accountType', AccountType.Checking);
                        }}
                        mr="16"
                      >
                        Checking
                      </Radio>

                      <Radio
                        checked={value === AccountType.Savings}
                        onChange={() => {
                          setValue('accountType', AccountType.Savings);
                        }}
                      >
                        Savings
                      </Radio>
                    </>
                  );
                }}
              />
            </Box>
          </Column>
        </Row>
      </Grid>
    </Wrapper>
  );
};
